<section>
    
    <div class="close"><mat-icon (click)="closeDialog()">close</mat-icon></div>
    <div class="crt">Edit SubAdmin Profile</div>
    <div class="form">
      <form [formGroup]="editadmin">
    <div class="form-outline mb-4">
        <label class="form-label" for="registerUsername"> Name:</label>
        <input type="text" id="registerUsername" class="form-control" formControlName="name"/>
       
      </div>
      <div class="form-outline mb-4">
        <label class="form-label" for="registerUsername" >PhoneNumber:</label>
        <input type="number" id="registerUsername" class="form-control" formControlName="phoneNo"/>
       
      </div>
      <div class="form-outline mb-4">
        <label class="form-label" for="registerUsername">Email</label>
        <input type="email" id="registerUsername" class="form-control" formControlName="email" />
       
      </div>
      <div class="form-outline mb-4" style="display: flex;justify-content: center;margin-top: 35px;">
        <button type="submit" class="btn btn-primary btn-block mb-3" style="width:50%;" (click)=" editprofile()">Submit</button>
    
       
      </div>
      </form>
    </div>
  </section>

